import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';
import { imageSourceBreakpoints } from 'js/breakpoints';

const positions = {
  right: 'right',
  left: 'left',
  center: 'center',
};

const getImageSources = imagePosition => {
  switch (imagePosition) {
    case positions.left:
    case positions.right:
      return [
        { width: 382, media: imageSourceBreakpoints.xs },
        { width: 720, media: imageSourceBreakpoints.s },
        { width: 717, media: imageSourceBreakpoints.m },
        { width: 925, media: imageSourceBreakpoints.l },
      ];

    case positions.center:
      return [
        { width: 382, media: imageSourceBreakpoints.xs },
        { width: 720, media: imageSourceBreakpoints.s },
        { width: 650, media: imageSourceBreakpoints.m },
      ];

    default:
      return [];
  }
};

const ImageBlock = ({ image, caption, position }) => {
  return image ? (
    <div
      className={cn('image-block', {
        [`image-block_position_${position}`]: position,
      })}
    >
      <figure className="image-block__container">
        <Image
          {...image}
          sources={getImageSources(position)}
          transform="fit"
          loading="lazy"
          className={cn('image-block__image', {
            [`image_size_image-block-${position}`]: position,
          })}
        />
        {caption && (
          <figcaption className="image-block__caption">{caption}</figcaption>
        )}
      </figure>
    </div>
  ) : null;
};

ImageBlock.propTypes = {
  image: PropTypes.exact(Image.propTypes).isRequired,
  caption: PropTypes.string,
  position: PropTypes.oneOf(Object.values(positions)).isRequired,
};

export default ImageBlock;
